import { render, staticRenderFns } from "./RealGraph.vue?vue&type=template&id=2fad098d"
import script from "./RealGraph.vue?vue&type=script&lang=js"
export * from "./RealGraph.vue?vue&type=script&lang=js"
import style0 from "./RealGraph.vue?vue&type=style&index=0&id=2fad098d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports